import styled from "styled-components";

export const Container = styled.div`
  height: 150px;
  text-align: center;
  background-color: teal;
`;

export const Header = styled.h1``;

export const Title = styled.div`
  padding-top: 20px;
  color: #fff;
`;
